'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface CTAButtonProps {
  text: string;
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
}

export default function CTAButton({
  text,
  onClick,
  variant = 'primary',
}: CTAButtonProps) {
  if (variant === 'primary') {
    return (
      <a
        href="https://3qoXrM.short.gy/8E4z28"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-between w-full sm:w-auto bg-accent text-accent-foreground px-8 sm:px-10 py-4 sm:py-5 rounded-full font-bold text-base sm:text-lg hover:bg-accent-hover transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 group"
      >
        <span>{text}</span>
        <Icon
          name="ArrowRightIcon"
          size={20}
          className="ml-3 sm:ml-4 transition-transform group-hover:translate-x-1 sm:w-6 sm:h-6"
        />
      </a>
    );
  }

  return (
    <a
      href="https://3qoXrM.short.gy/8E4z28"
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center justify-center w-full sm:w-auto border-2 border-white text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold text-sm sm:text-base hover:bg-white hover:text-primary transition-all duration-300 group"
    >
      <span>{text}</span>
    </a>
  );
}